import { create } from 'zustand'

const SLOW_MS = 5000
const STREAK_TO_SWITCH = 2

export type RequestOutcome = 'ok' | 'failed' | 'cancelled'

type ConnectionQualityState = {
  isPoor: boolean
  badStreak: number
  goodStreak: number
  report: (good: boolean) => void
}

export const useConnectionQualityStore = create<ConnectionQualityState>(
  (set, get) => ({
    isPoor: false,
    badStreak: 0,
    goodStreak: 0,
    report: (good) => {
      const { isPoor, badStreak, goodStreak } = get()
      if (good) {
        const streak = goodStreak + 1
        set({
          goodStreak: streak,
          badStreak: 0,
          isPoor: isPoor && streak < STREAK_TO_SWITCH,
        })
      } else {
        const streak = badStreak + 1
        set({
          badStreak: streak,
          goodStreak: 0,
          isPoor: isPoor || streak >= STREAK_TO_SWITCH,
        })
      }
    },
  }),
)

// iOS fails in-flight requests on suspend, which says nothing about the network
let lastHiddenAt = 0
document.addEventListener('visibilitychange', () => {
  if (document.hidden) lastHiddenAt = Date.now()
})

export const trackRequest = () => {
  const startedAt = Date.now()
  const report = (good: boolean) => {
    if (document.hidden || lastHiddenAt >= startedAt) return
    useConnectionQualityStore.getState().report(good)
  }

  // Still pending at SLOW_MS counts as bad now, not when it finally settles
  let slow = false
  const timer = setTimeout(() => {
    slow = true
    report(false)
  }, SLOW_MS)

  return (outcome: RequestOutcome) => {
    clearTimeout(timer)
    if (slow || outcome === 'cancelled') return
    report(outcome === 'ok')
  }
}
